import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as FlagIcon } from '../../../assets/images/common/icons/weavy-flag-icon.svg'
import { ReactComponent as GroupIcon } from '../../../assets/images/common/icons/users-group-icon.svg'
import AccountSegmentCard from './AccountSegmentCard'

const COACH_FORM_URL =
  'https://share.hsforms.com/18DFr5TiZRhef_vcDS9dWYAqm7oy?utm_source=op36app&utm_medium=registrationform&utm_campaign=openexperience'

const AccountSegmentSelector = ({ onIndividualClick, onFamilyClick, showHeaders, wrapperClassName, cardClassName }) => {
  const { t } = useTranslation()

  const handleCoachClick = () => {
    const isProduction = process.env.NODE_ENV === 'production' && process.env.REACT_APP_BASE_URL === 'https://operation36golf.com'

    if (!isProduction) {
      alert('Disabled (Not in production)') // eslint-disable-line no-alert
      return
    }

    window.location.href = COACH_FORM_URL
  }

  return (
    <>
      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={GolferIcon}
          title={t('auth.accountSegmentSelector.individualTitle')}
          description={t('auth.accountSegmentSelector.individualDescription')}
          onClick={onIndividualClick}
          showHeader={showHeaders}
          headerText={t('auth.accountSegmentSelector.individualHeader')}
          className={cardClassName}
        />
      </div>

      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={GroupIcon}
          title={t('auth.accountSegmentSelector.familyTitle')}
          description={t('auth.accountSegmentSelector.familyDescription')}
          onClick={onFamilyClick}
          showHeader={showHeaders}
          headerText={t('auth.accountSegmentSelector.familyHeader')}
          className={cardClassName}
        />
      </div>

      <div className={wrapperClassName}>
        <AccountSegmentCard
          icon={FlagIcon}
          title={t('auth.accountSegmentSelector.coachTitle')}
          description={t('auth.accountSegmentSelector.coachDescription')}
          onClick={handleCoachClick}
          showHeader={showHeaders}
          headerText={t('auth.accountSegmentSelector.coachHeader')}
          className={cardClassName}
        />
      </div>
    </>
  )
}

AccountSegmentSelector.propTypes = {
  onIndividualClick: PropTypes.func.isRequired,
  onFamilyClick: PropTypes.func.isRequired,
  showHeaders: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  cardClassName: PropTypes.string,
}

export default AccountSegmentSelector
